import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import _ from 'lodash';

export type BTN_STYLE =
    | 'primary'
    | 'primary-outline'
    | 'tertiary-outline'
    | 'secondary'
    | 'tertiary'
    | 'fourth'
    | 'success'
    | 'success-outline'
    | 'danger'
    | 'warning'
    | 'info'
    | 'light'
    | 'light-outline'
    | 'dark'
    | 'dark-outline'
    | 'link'
    | 'link-tertiary'
    | 'link-fifth'
    | 'link-light'
    | 'search'
    | 'promo'
    | 'promo-mobile'
    | 'link2btn'
    | 'sixth'
    | 'cancel';

@Component({
    selector: 'fe-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ButtonComponent implements OnChanges {
    public styleMap = {
        primary: 'btn-primary',
        'primary-outline': 'btn-outline-primary',
        'tertiary-outline': 'btn-outline-tertiary',
        secondary: 'btn-secondary',
        tertiary: 'btn-tertiary',
        success: 'btn-success',
        'success-outline': 'btn-outline-success',
        danger: 'btn-danger',
        warning: 'btn-warning',
        info: 'btn-info',
        light: 'btn-light',
        'light-outline': 'btn-outline-light',
        dark: 'btn-dark',
        'dark-outline': 'btn-outline-dark',
        link: 'btn-link',
        'link-light': 'btn-link light',
        search: 'reservation__item__btn',
        link2btn: 'link2btn',
        promo: 'promo',
        'promo-mobile': 'promo mobile',
        fourth: 'btn-fourth',
        cancel: 'cancel',
        sixth: 'btn-sixth',
        'link-tertiary': 'btn-link btn-link-tertiary',
        'link-fifth': 'btn-link btn-link-fifth',
    };

    @Input() style: BTN_STYLE = 'primary';

    @Input() type = 'button';

    @Input() icon: string | null = null;

    @Input() iconFormat = 'svg';

    @Input() iconPosition: 'left' | 'right' = 'left';

    @Input() disabled = false;

    @Input() onlyIcon = false;

    @Input() underline = false;

    @Input() loading = false;

    @Input() href: string | null = null;

    @Input() fragment?: string;

    @Input() arrowAnimate = false;

    @Input() data = {};

    @Input() btnClass = '';

    @Input() btnStyle = null;

    @Input() role = 'button';

    @Input() tabIndex = '0';

    @Input() size: 'small' | 'normal' | 'large' = 'normal';

    @Input() target: '_self' | '_blank' | '_parent' | '_top' = '_self';

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onClick = new EventEmitter<Event>();

    public clicked = false;

    constructor(
        private readonly router: Router,
        private elementRef: ElementRef,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (this.disabled) {
            this.elementRef.nativeElement.classList.add('disabled');
        } else {
            this.elementRef.nativeElement.classList.remove('disabled');
        }
        if (this.loading) {
            this.elementRef.nativeElement.classList.add('loading');
        } else {
            this.elementRef.nativeElement.classList.remove('loading');
        }
    }

    public isValidUrl() {
        return (
            !_.includes(this.href, 'tel:') &&
            !_.includes(this.href, 'mailto:') &&
            !_.includes(this.href, 'https:') &&
            !_.includes(this.href, 'http:')
        );
    }

    public handleClick(event: Event): void {
        if (this.disabled || this.loading) {
            return;
        }
        if (this.href != null) {
            this.clicked = true;
            this.router.navigateByUrl(this.href, { state: this.data });
        } else {
            this.clicked = true;
            this.onClick.emit(event);
        }
    }

    public handleKeyDown(event: KeyboardEvent): void {
        if (this.disabled) {
            return;
        }
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.handleClick(event);
        }
    }
}
